export const NOT_FOUND_STATUS_CODE = '404'

export const ROUTES = {
  path: '/',
  FEATURE: {
    path: '/:featureName',
    HIERARCHY_ID: {
      path: 'hierarchyId/:hierarchyId/*'
    }
  },
  NOT_FOUND: {
    path: `/${NOT_FOUND_STATUS_CODE}`
  }
} as const
